import { render } from "./investmentForm.vue?vue&type=template&id=0e403a6d"
import script from "./investmentForm.vue?vue&type=script&lang=js"
export * from "./investmentForm.vue?vue&type=script&lang=js"

import "./investmentForm.vue?vue&type=style&index=0&id=0e403a6d&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__